export const GET_USER_STATS = "app/STATS/GET_USER_STATS";
export const GET_USER_STATS_SUCCESS = "app/STATS/GET_USER_STATS_SUCCESS";
export const GET_USER_STATS_FAILURE = "app/STATS/GET_USER_STATS_FAILURE";

export const GET_ROTA_STATS = "app/STATS/GET_ROTA_STATS";
export const GET_ROTA_STATS_SUCCESS = "app/STATS/GET_ROTA_STATS_SUCCESS";
export const GET_ROTA_STATS_FAILURE = "app/STATS/GET_ROTA_STATS_FAILURE";

export const SET_OPEN_SHIFT = "app/STATS/SET_OPEN_SHIFT";
export const SET_DROP_REQUESTS = "app/STATS/SET_DROP_REQUESTS";
export const SET_MY_DROPPED_SHIFTS = "app/STATS/SET_MY_DROPPED_SHIFTS";
export const SET_UPCOMING_SHIFTS = "app/STATS/SET_UPCOMING_SHIFTS";
export const SET_PULSE_SURVEY_LIST = "app/STATS/SET_PULSE_SURVEY_LIST";
export const REMOVE_PULSE_SURVEY = "app/STATS/REMOVE_PULSE_SURVEY";
export const SET_FEED_LIST = "app/STATS/SET_FEED_LIST";
export const SET_SWAP_REQUESTS = "app/STATS/SET_SWAP_REQUESTS";
export const SET_SWAP_APPROVALS = "app/STATS/SET_SWAP_APPROVALS";

export const TOGGLE_VIEW_MODAL = "app/STATS/TOGGLE_VIEW_MODAL";

// MODERN DASHBOARD
export const GET_HR_STATS = "app/STATS/GET_HR_STATS";
export const GET_HR_STATS_SUCCESS = "app/STATS/GET_HR_STATS_SUCCESS";
export const GET_HR_STATS_FAILURE = "app/STATS/GET_HR_STATS_FAILURE";

export const GET_SURVEY_STATS = "app/STATS/GET_SURVEY_STATS";
export const GET_SURVEY_STATS_SUCCESS = "app/STATS/GET_SURVEY_STATS_SUCCESS";
export const GET_SURVEY_STATS_FAILURE = "app/STATS/GET_SURVEY_STATS_FAILURE";

export const GET_SHIFT_APPROVALS = "app/STATS/GET_SHIFT_APPROVALS";
export const GET_SHIFT_APPROVALS_SUCCESS =
  "app/STATS/GET_SHIFT_APPROVALS_SUCCESS";
export const GET_SHIFT_APPROVALS_FAILURE =
  "app/STATS/GET_SHIFT_APPROVALS_FAILURE";

export const GET_STAFF_OPS = "app/STATS/GET_STAFF_OPS";
export const GET_STAFF_OPS_SUCCESS = "app/STATS/GET_STAFF_OPS_SUCCESS";
export const GET_STAFF_OPS_FAILURE = "app/STATS/GET_STAFF_OPS_FAILURE";

export const GET_TEAM_ACTIVITY = "app/STATS/GET_TEAM_ACTIVITY";
export const GET_TEAM_ACTIVITY_SUCCESS = "app/STATS/GET_TEAM_ACTIVITY_SUCCESS";
export const GET_TEAM_ACTIVITY_FAILURE = "app/STATS/GET_TEAM_ACTIVITY_FAILURE";

export const GET_LEAD_ANALYTICS = "app/STATS/GET_LEAD_ANALYTICS";
export const GET_LEAD_ANALYTICS_SUCCESS =
  "app/STATS/GET_LEAD_ANALYTICS_SUCCESS";
export const GET_LEAD_ANALYTICS_FAILURE =
  "app/STATS/GET_LEAD_ANALYTICS_FAILURE";

export const GET_TEAM_COMM = "app/STATS/GET_TEAM_COMM";
export const GET_TEAM_COMM_SUCCESS = "app/STATS/GET_TEAM_COMM_SUCCESS";
export const GET_TEAM_COMM_FAILURE = "app/STATS/GET_TEAM_COMM_FAILURE";
